export const DELETE_REASON_OPTIONS = [
  'Duplicate',
  'Wrong Patient',
  'Incorrect Upload',
  'Test/Error',
  'Other',
] as const;

export type DeleteReason = (typeof DELETE_REASON_OPTIONS)[number];
